// extracted by mini-css-extract-plugin
module.exports = {"section":"development-module--section--1_ALP","container":"development-module--container--2XlgZ","plate":"development-module--plate--1_Nwu"};